var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bizfly-ui bizfly-release-notes"},[_c('div',{staticClass:"release-notes-btn",class:_vm.onLeft ? 'on-left' : 'on-right'},[_c('bizfly-support-dialog',{attrs:{"url":_vm.releaseUrl}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }